// Funzione per fare il truncate delle stringhe con 3 punti. Prende come input la stringa ed il numero di caratteri.
export const  truncateString = (string, num) =>  string.length <= num ? string : string.slice(0, num) + '...';


